import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './rtl.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // react-snap pre-rendered HTML exists — hydrate over it
  ReactDOM.hydrateRoot(rootElement, <App />);
} else {
  ReactDOM.createRoot(rootElement).render(<App />);
}

reportWebVitals();
